import {
  meaningBodyOf,
  meaningTeachingMatches,
} from "../content/lianxi/yufa-meaning.js";
import { focusedGroup } from "./lianxi-yufa-focused.js";
import { teachingOn } from "./lianxi-yufa-teaching.js";

/** Clear the previous result before a later practice attempt. */
export function resetVisualOptions(form: HTMLFormElement): void {
  for (const option of form.querySelectorAll<HTMLElement>(
    ".lianxi-yufa-visual-option",
  )) {
    delete option.dataset["cbYufaResult"];
    const label = option.querySelector<HTMLElement>(
      "[data-cb-yufa-visual-result]",
    )!;
    label.hidden = true;
    label.textContent = "";
  }
}

/** Mark scene matches, including grammatical sentences that describe another scene. */
export function markVisualOptions(form: HTMLFormElement): void {
  const group = focusedGroup(form);
  const body = meaningBodyOf(
    JSON.parse(group?.dataset["cbYufaMeaning"] ?? "null") as unknown,
  );
  if (
    body?.visual === undefined ||
    !meaningTeachingMatches(body, teachingOn(form)) ||
    group?.value === undefined ||
    group.value === null ||
    group.value === ""
  ) {
    return;
  }
  for (const option of group.querySelectorAll<HTMLElement>(
    ".lianxi-yufa-visual-option",
  )) {
    const value = option.getAttribute("value");
    const matches = body.accepted.includes(Number(value));
    if (!matches && value !== group.value) {
      continue;
    }
    option.dataset["cbYufaResult"] = matches ? "match" : "mismatch";
    const label = option.querySelector<HTMLElement>(
      "[data-cb-yufa-visual-result]",
    )!;
    label.textContent = matches
      ? "Matches the scene"
      : "Does not match the scene";
    label.hidden = false;
  }
}
